<template>
  <div class="page flex-col">
    <div class="group_2 flex-col">
        <div class="box_2 flex-row">
          <span class="text_7" style="cursor: pointer" @click="handleJump('/home')">首页</span>
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
          />
          <span class="text_8" style="cursor: pointer" @click="handleClick(0, true)">加入我们</span>
          <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
          />
          <span class="text_9" style="cursor: pointer" @click="handleClick(0)">企业现状</span>
          <img
            class="thumbnail_3"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
          />
          <span class="text_10">竞品分析</span>
        </div>
        <div class="box_3 flex-col">
          <span class="paragraph_1">
            &ensp;&ensp;&ensp;&ensp;公办院校大概率采用公开招投标方式对外发包，部分标的物通过教育体系、政府体系、校方、军方等邀请式投标。现在也存在政府主导校园后勤板块整体外包的情况。
            <br />
            &ensp;&ensp;&ensp;&ensp;民办院校更多的采用谈判式外包，或是乙方承建食堂、商业宿舍等建完后甲方用经营权置换建设款，置换时间通常是10-20年的经营权（无承包费）。
            <br />
            &ensp;&ensp;&ensp;&ensp;目前校园行业中，有做得比较好的企业，但这些公司没有把校园经济给发挥出最大价值。由于服务单一，做不到统一规划、合理布局，造成行业内卷的情况很明显。更没有重视民办高校的优势和潜力。
          </span>
          <div class="section_2 flex-col"></div>
        </div>
        <div class="image-text_1 flex-row justify-between" style="cursor: pointer" @click="handleClick(0)">
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./../../assets/img/return.webp"
          />
          <span class="text-group_1">返回</span>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    handleJump(url, data = {}) {
      if (url === this.$route.path) return;
      this.$router.push({
        path: url,
        query: data
      });
      window.scrollTo(0,0);
    },
    handleClick(value, top = false) {
      this.$emit('select', value, top);
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
